import {
    Backdrop,
    Box,
    Button,
    Fade,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    Stack,
    Typography,
} from '@mui/material'
import { useState } from 'react'

interface IProps {
    handleClose: () => void
    open: boolean
    onSubmit: () => void
}

const Options = [
    {
        label: 'لو رفتن کلید خصوصی',
        value: '1',
    },
    {
        label: 'بازیابی در دستگاه دیگر',
        value: '2',
    },
    {
        label: 'بازیابی در سایر مرورگرها',
        value: '3',
    },
    {
        label: 'سایر',
        value: '3',
    },
]

export default function LogoutModal(props: IProps): JSX.Element {
    const { handleClose, open, onSubmit } = props

    // State
    const [reason, setReason] = useState<string>()

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            sx={{ zIndex: 10000 }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '30%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        bgcolor: 'background.paper',
                        borderRadius: 0.8,
                        p: 4,
                    }}
                >
                    <Typography
                        id="transition-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        آیا از خروج اطمینان دارید؟
                    </Typography>
                    <Typography
                        id="transition-modal-description"
                        sx={{
                            mt: 2,
                            color: (theme) => theme.palette.warning.main,
                        }}
                    >
                        در صورت خروج از برنامه، گواهی شما حذف می‌شود. در صورت
                        نیاز آن را پشتیبان‌گیری کنید.
                    </Typography>
                    <FormControl fullWidth sx={{ mt: 3 }}>
                        <InputLabel id="demo-simple-select-label">
                            دلیل خروج
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={reason}
                            label="دلیل خروج"
                            onChange={(e) => setReason(e.target.value)}
                            MenuProps={{
                                sx: { zIndex: 10001 },
                            }}
                        >
                            {Options.map((item) => (
                                <MenuItem
                                    value={item.value}
                                    key={Number(item.value)}
                                >
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Stack
                        direction="row"
                        mt={3}
                        spacing={3}
                        justifyContent="space-between"
                    >
                        <Button
                            variant="contained"
                            color="error"
                            fullWidth
                            onClick={() => {
                                onSubmit()
                            }}
                            disabled={!reason}
                        >
                            خروج
                        </Button>
                        <Button variant="outlined" onClick={handleClose}>
                            انصراف
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    )
}
